import 'mlmi-library'
import 'jquery.easing'
import '@fancyapps/fancybox'
import { CoreDetect_WebP, iOS, Android } from 'mlmi-library/utils/device'
import Carousel, { Carousel_CoreInit } from 'mlmi-library/components/carousel/v1/carousel'
import Accordion from 'mlmi-library/components/accordion/v1/accordion'
import Burger from 'mlmi-library/components/burger/v1/burger'
import Scrollbar from 'mlmi-library/components/scrollbar/v1/scrollbar'
import Tabs from 'mlmi-library/components/tabs/v1/tabs'
import Mobile from 'mlmi-library/modules/mobile/v1/mobile'
import Popup from 'mlmi-library/components/popup/v1/popup'
import { Hotspot_CoreInit } from 'mlmi-library/components/hotspot/v1/hotspot'
import 'mlmi-library/components/fixed-content/v1/fixed-content'
import 'mlmi-library/components/quantity/v1/quantity'
import 'mlmi-library/components/fade-in/v1/fade-in'
import 'mlmi-library/modules/scroll-events/v1/scroll-events'
import 'mlmi-library/plugins/scroll-to'
import 'mlmi-library/plugins/bem'
import 'mlmi-library/components/select/v1/select'
import Form from 'mlmi-library/components/form/v1/form'
import { Form_CoreInit } from 'mlmi-library/components/form/v1/form-builder'
import 'mlmi-library/components/floating-label/v1/floating-label'
import 'mlmi-library/components/file-input/v1/file-input'
import { getParameter, getParameters } from 'mlmi-library/utils/queries'

export { Tabs, Burger, Mobile, Popup, Carousel, Carousel_CoreInit, iOS, Android, Hotspot_CoreInit, Accordion, Scrollbar, Form, Form_CoreInit, getParameter, getParameters }

CoreDetect_WebP()
